import { createMqStyles } from "../../create-mq-styles";
import { tokens } from "../../tokens";
import { Text, type TextProps } from "./text";

type HeadingType = "hero" | "one" | "two" | "three" | "four" | "five";

export type HeadingTextProps = Omit<TextProps, "weight"> & {
  type: HeadingType;
};

export function HeadingText({ type, selectable = true, ...props }: HeadingTextProps) {
  const styles = useMqStyles();

  return (
    <Text
      {...props}
      selectable={selectable}
      weight={type === "hero" ? "bold" : "semibold"}
      style={[styles.baseline, styles[type], props.style]}
      role="heading"
    />
  );
}

const useMqStyles = createMqStyles({
  baseline: {
    $base: {
      color: tokens.colors.$houseDark,
    },
  },
  hero: {
    $base: { fontSize: 28, lineHeight: 30 },
    $gtLg: { fontSize: 48, lineHeight: 52 },
  },
  one: {
    $base: { fontSize: 24, lineHeight: 28 },
    $gtLg: { fontSize: 30, lineHeight: 32 },
  },
  two: {
    $base: { fontSize: 18, lineHeight: 22 },
    $gtLg: { fontSize: 24, lineHeight: 28 },
  },
  three: {
    $base: { fontSize: 16, lineHeight: 20 },
    $gtLg: { fontSize: 18, lineHeight: 20 },
  },
  four: {
    $base: { fontSize: 14, lineHeight: 16 },
    $gtLg: { fontSize: 16, lineHeight: 18 },
  },
  five: {
    $base: { fontSize: 12, lineHeight: 14 },
    $gtLg: { fontSize: 14, lineHeight: 16 },
  },
});
